import { AD_TYPE } from '@seek/je-shared-data';

export const basicOrUndefined = (adType: AD_TYPE | undefined) =>
  [undefined, AD_TYPE.BASIC].includes(adType);
